import { FC, PropsWithChildren, ReactNode, useContext } from "react";
import { AutoLogout, HeaderActionBar, Footer } from "@/components";
import { AuthenticationContext } from "@/context";

import styles from "./PageLayout.module.scss";

interface PageLayoutProps {
  children: ReactNode;
}

export const PageLayout: FC<PropsWithChildren<PageLayoutProps>> = ({ children }: PropsWithChildren<PageLayoutProps>) => {
  const { isUserLoggedIn } = useContext(AuthenticationContext);

  return (
    <div className={styles.PageContainer}>
      {isUserLoggedIn() && <AutoLogout />}
      <HeaderActionBar />
      <div role="main" className={styles.LayoutBackground}>
        {children}
      </div>
      <Footer />
    </div>
  );
};
